export const setMembershipCardsScannerPopupOpen = (value, action) => {
  return {
    type: "SET_MEMBERSHIP_CARDS_SCANNER_POP_OPEN",
    payload: { data: value, action},
  };
};

export const setRFIDCardIdValue = (value) => {
  return {
    type: "SET_RFID_CARD_ID_VALUE",
    payload: { data: value },
  };
};
  
export const setMemberGymByMembershipCardId = (value) => {
  return {
    payload: { data: value },
    type: "SET_MEMBER_GYM_BY_MEMBERSHIP_CARD_ID",
  };
};
